import * as cellModule from './FullDashboardCell'
import { useCell } from 'src/lib/cellWrapper'

export default (props) => useCell(cellModule, props)
